// CSV helpers for the activity graph download. Kept separate from utils.ts so
// graph utilities (and their tests) don't pull in the download/DOM helpers.
import { V1DownloadCloudEventsActivityAccessResponse } from '@ariksa/audittrail/api';
import dayjs from 'dayjs';

import { saveAsFile } from 'utils/download';

const BASE64_PATTERN = /^[A-Za-z0-9+/]+={0,2}$/;

/* The download API returns CSV bytes, which the JSON gateway base64-encodes.
   Decode when the payload is base64 and fall back to raw text otherwise. */
export const decodeActivityAccessesCsv = (content?: string) => {
  const value = String(content ?? '');
  const compact = value.replace(/\s/g, '');
  if (!compact || compact.length % 4 !== 0 || !BASE64_PATTERN.test(compact)) {
    return value;
  }
  try {
    const binary = atob(compact);
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
  } catch {
    return value;
  }
};

/* Build the activity graph CSV name in the same format as other Ariksa CSV
   exports: report name, resource name and local download timestamp. */
export const getActivityGraphCsvFileName = (resourceName?: string | String) =>
  'Ariksa - Activity Graph_' +
  (resourceName ? String(resourceName) + '_' : '') +
  dayjs().format('DD-MMM-YYYY h.mm A') +
  '.csv';

/* Save the activity graph CSV returned by the activity-accesses download API.
   Uses our standard file name instead of the generic API file_name. */
export const saveActivityAccessesCsv = (
  response?: V1DownloadCloudEventsActivityAccessResponse | null,
  resourceName?: string | String,
) => {
  saveAsFile(
    decodeActivityAccessesCsv(response?.content as string),
    getActivityGraphCsvFileName(resourceName),
    String(response?.content_type || 'text/csv;charset=utf-8;'),
  );
};
